// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".theme-provider>.error-catcher,.authenticated-page-wrapper>.error-catcher{padding:2rem}", "",{"version":3,"sources":["webpack://./scss/utilities/error-catcher.scss"],"names":[],"mappings":"AAEE,0EACE,YAAA","sourcesContent":[".theme-provider, \n.authenticated-page-wrapper {\n  & > .error-catcher {\n    padding: 2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
